module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_07.36cccbda.svg";